export const formattedPhone = (clearedPhone: string) => {
  let res = ''
  const cleaned = `${clearedPhone}`.replace(/\D/g, '')
  if (cleaned[0]) {
    res += `+${cleaned[0]}`
  }

  let next = cleaned.slice(1, 4)
  if (next.length) {
    res += ` (${next}`
  }

  next = cleaned.slice(4, 7)
  if (next.length) {
    res += `) ${next}`
  }

  next = cleaned.slice(7, 9)
  if (next.length) {
    res += `-${next}`
  }

  next = cleaned.slice(9)
  if (next.length) {
    res += `-${next}`
  }
  return res
}
